import { type ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';
import {
    type AttributeDefinitionType,
    type CustomTypeAttribute,
} from '@components/CustomAttributes';
import {
    TypeBasedField,
    type AttributeFieldType,
} from '@components/TypeBasedField';
import { type ProjectAttribute } from '@gql/graphql';
import { type ProjectFormAttributes } from '../ProjectForm';

const mapAttributeDefinitionTypePlaceholder: Record<
    AttributeDefinitionType,
    string
> = {
    DATE: 'DD.MM.YYYY',
    DATETIME: 'DD.MM.YYYY HH:mm',
    STRING: 'Enter text',
    NUMBER: 'Enter number',
};

function mapAttribute(attr: ProjectAttribute): CustomTypeAttribute {
    return {
        ...attr,
        name: attr.label,
    };
}

export function ProjectFormAttributesInput(): ReactNode {
    const formContext = useFormContext<ProjectFormAttributes>();

    const customAttributes = formContext.watch('projectAttributes');

    if (!customAttributes?.length) {
        return (
            <p className="text-center text-xs">
                Project Additional properties could be added later in the{' '}
                <strong>Project</strong> tab on the{' '}
                <strong>Project Settings</strong> page.
            </p>
        );
    }

    return (
        <>
            {customAttributes.map((attribute, index) => {
                const mapped = mapAttribute(attribute);
                const placeholder =
                    mapAttributeDefinitionTypePlaceholder[attribute.type];
                return (
                    <TypeBasedField
                        key={attribute.id}
                        fieldType={mapped.type as AttributeFieldType}
                        name={`projectAttributes.${index}.value`}
                        label={mapped.name}
                        placeholder={placeholder}
                        maxLength={100}
                    />
                );
            })}
        </>
    );
}
